// extracted by mini-css-extract-plugin
export var copy = "stats-module--copy--orxxs";
export var item = "stats-module--item--Uvdws";
export var stat = "stats-module--stat--s5DXG";
export var suffix = "stats-module--suffix--5lm32";
export var wrap = "stats-module--wrap--PibCH";